namespace Catalogo {
    const KeyupRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    const KeySpecials = ["Enter", "Backspace", "Control", "Delete"];
    let KeyupTimer;
    const operationSecondTimeoutMs = 1000; // 1 second

    export namespace Lista {
        let filtriAttivati: boolean = false;
        let FiltroCatalogoLista: RequestCatalogoDto;
        export function Init(baseUrlFiltro: string, divTabella: string, bodyTabella: string, rigaTabella: string, loaderInfiniteScroll: string, initRowPerPage: number) {
            ResetFiltro(initRowPerPage);
            const opzioni: Controlli.UtilityTabella.BaseInfiniteScrollOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
            const tabella = Controlli.UtilityTabella.InitInfiniteScroll(opzioni, Controlli.Utility.HttpMethod.POST, FiltroCatalogoLista, null);
            
            // Inizializza Select2 per le marche
            const $selectMarche = $("[data-sav-marche-catalogo-lista]");
            if ($selectMarche.length > 0) {
                $selectMarche.select2({
                    placeholder: "Seleziona marche...",
                    theme: 'bootstrap-5',
                    containerCssClass: "select2--small",
                    dropdownCssClass: "select2--small",
                    allowClear: false,
                    width: '100%',
                    language: {
                        noResults: function () {
                            return "Nessuna marca trovata";
                        }
                    },
                    templateSelection: function (data) {
                        // Personalizza il rendering dei tag selezionati
                        var $selection = $('<span class="text-white fw-semibold"></span>');
                        $selection.text(data.text);
                        return $selection;
                    }
                });
            }

            //Filtro delle tab
            $("[data-sav-catalogo-articoloevidenza]").on("click", function () {
                let newTipo = $(this).data("sav-catalogo-articoloevidenza") as TabsFiltriCatalogo;
                if (FiltroCatalogoLista.evidenzaArticoli != newTipo) {
                    FiltroCatalogoLista.evidenzaArticoli = newTipo;
                    if (FiltroCatalogoLista.evidenzaArticoli == TabsFiltriCatalogo.NOVITA) {
                        FiltroCatalogoLista.isNovita = true;
                    } else {
                        FiltroCatalogoLista.isNovita = false;
                    }
                    let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                    ReloadTable(opzioni, tabella);
                    CambiaStileBottoneResetFiltri(true);
                }
            });
            //Filtro ricerca testuale
            $("[data-sav-ricerca-catalogo-lista]").on("keyup", function (e,) {
                let searchTerm: string = $(this).val() as string;
                let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                if (searchTerm !== FiltroCatalogoLista.RicercaTestuale && (searchTerm == '' || KeyupRegex.test(searchTerm) || KeySpecials.includes(e.key))) {
                    let searchTerm: string = $("[data-sav-ricerca-catalogo-lista]").val() as string;
                    FiltroCatalogoLista.RicercaTestuale = searchTerm;
                    clearTimeout(KeyupTimer);
                    KeyupTimer = setTimeout(() => ReloadTable(opzioni, tabella), operationSecondTimeoutMs);
                    CambiaStileBottoneResetFiltri(true);
                }
            });
            //Filtro Cataloghi
            $(`[data-sav-cataloghi-lista]`).on("click", function () {
                let catalogo = $(this).data("sav-cataloghi-lista") as number | null;

                $("[data-sav-cataloghi-lista] h5").removeClass("text-info");
                $(this).find("h5").addClass("text-info");

                FiltroCatalogoLista.CatalogoSelezionatoId = catalogo;

                CambiaStileBottoneResetFiltri(true);
                let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                ReloadTable(opzioni, tabella);
            });
            //Filtro Categorie
            $("[data-sav-categorie-catalogo-lista], [data-sav-sottocategorie-catalogo-lista]").on("click", function () {
                let categoria = $(this).data("sav-categorie-catalogo-lista") as number | null;
                let sottocategoria = $(this).data("sav-sottocategorie-catalogo-lista") as number | null;
                $("[data-sav-categorie-catalogo-lista] h5, [data-sav-sottocategorie-catalogo-lista] h5").removeClass("text-info");
                $(this).find("h5").addClass("text-info");
                if (sottocategoria != null) {
                    $(`[data-sav-categorie-catalogo-lista='${categoria}']`).not("[data-sav-sottocategorie-catalogo-lista]").find("h5").addClass("text-info");
                } else {
                    $("[data-sav-categorie-catalogo-lista]").not("[data-sav-sottocategorie-catalogo-lista]").each(function () {
                        const catId = $(this).data("sav-categorie-catalogo-lista");
                        if (catId !== categoria) {
                            $(this).next("div.collapse").removeClass("show");
                        }
                    });

                    //$(`#categoria${categoria}`).addClass("show");

                    $("[data-sav-categorie-catalogo-lista], [data-sav-sottocategorie-catalogo-lista]").addClass("collapsed");
                    $(this).removeClass("collapsed");
                }

                FiltroCatalogoLista.categoriaId = categoria;
                FiltroCatalogoLista.sottoCategoriaId = sottocategoria;

                CambiaStileBottoneResetFiltri(true);
                let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                ReloadTable(opzioni, tabella);
            })
            //Filtro Marche con Select2
            $selectMarche.on("change", function () {
                const valoriSelezionati = $(this).val() as string[];
                FiltroCatalogoLista.marcheSelezionate = valoriSelezionati ? valoriSelezionati.map(v => parseInt(v, 10)) : [];

                CambiaStileBottoneResetFiltri(true);
                let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                ReloadTable(opzioni, tabella);
            });
            //Filtro Tags
            $("[data-sav-listatag-catalogo-lista]").on("click", function () {
                CambiaStileBottoneResetFiltri(true);
                $(this).toggleClass("bg-info")
                $(this).toggleClass("border border-primary text-primary")
                let tagId = $(this).data("sav-listatag-catalogo-lista") as number;
                const index = FiltroCatalogoLista.elencoTagSelezionati.indexOf(tagId);
                if (index === -1) {
                    // Valore non presente, lo aggiungiamo
                    FiltroCatalogoLista.elencoTagSelezionati = [...FiltroCatalogoLista.elencoTagSelezionati, tagId];
                } else {
                    // Valore presente, lo rimuoviamo
                    FiltroCatalogoLista.elencoTagSelezionati = FiltroCatalogoLista.elencoTagSelezionati.slice(0, index).concat(FiltroCatalogoLista.elencoTagSelezionati.slice(index + 1));
                }
                let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                ReloadTable(opzioni, tabella);
            })

            //Reset filtri
            $("[data-sav-puliscifiltri-catalogo-lista]").on("click", function () {
                if (filtriAttivati) {
                    ResetFiltro(initRowPerPage);
                    //Reset stile evidenza ad ALL
                    $("[data-sav-catalogo-articoloevidenza]").removeClass("active");
                    $(`[data-sav-catalogo-articoloevidenza="${TabsFiltriCatalogo.ND}"]`).addClass('active');
                    //Reset stile ricerca testuale
                    $("[data-sav-ricerca-catalogo-lista]").val("");
                    //Reset stile cataloghi
                    $("[data-sav-cataloghi-lista]").removeClass("active show");
                    $("[data-sav-cataloghi-lista] h5").removeClass("text-info");
                    //Reset stile categorie
                    $("[data-sav-categorie-catalogo-lista], [data-sav-sottocategorie-catalogo-lista]").removeClass("active show");
                    $("[data-sav-categorie-catalogo-lista] h5, [data-sav-sottocategorie-catalogo-lista] h5").removeClass("text-info");
                    $("[data-sav-categorie-catalogo-lista]").not("[data-sav-sottocategorie-catalogo-lista]").each(function () {
                        $(this).next("div.collapse").removeClass("show");
                    });
                    //reset marche con Select2
                    $selectMarche.val(null).trigger('change');
                    //reset tags
                    $("[data-sav-listatag-catalogo-lista]").removeClass("bg-info")
                    $("[data-sav-listatag-catalogo-lista]").addClass("border border-primary text-primary")
                    let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
                    ReloadTable(opzioni, tabella);
                    CambiaStileBottoneResetFiltri();
                }
            })
        }

        function ReloadTable(opzioni: BaseFiltriOptions, infiniteScrollTable: any) {
            Controlli.Utility.fadeOutFadeIn($(opzioni.bodyTabella), () => {
                Controlli.UtilityTabella.ResetInfiniteScroll(
                    opzioni,
                    infiniteScrollTable,
                    Controlli.Utility.HttpMethod.POST,
                    FiltroCatalogoLista,
                    null
                );
            });
        }
        function ResetFiltro(initRowPerPage: number) {
            FiltroCatalogoLista = {
                PaginaAttuale: 1,
                PagineTotali: 2,
                RighePerPagina: initRowPerPage,
                GenericId: 0,
                DataFine: null,
                DataInizio: null,
                RicercaTestuale: '',
                elencoTagSelezionati: [],
                isNovita: false,
                marcheSelezionate: [],
                categoriaId: null,
                evidenzaArticoli: TabsFiltriCatalogo.ND,
                sottoCategoriaId: null,
                connectionId: $.connection.hub.id,
            }
        }
        function CambiaStileBottoneResetFiltri(attiva: boolean = false) {
            if (attiva) {
                $("[data-sav-puliscifiltri-catalogo-lista]").removeClass("link-primary")
                $("[data-sav-puliscifiltri-catalogo-lista]").addClass("link-secondary")
                $("[data-sav-puliscifiltri-catalogo-lista]").addClass("text-decoration-underline")
                filtriAttivati = true;
            } else {
                $("[data-sav-puliscifiltri-catalogo-lista]").removeClass("text-decoration-underline");
                $("[data-sav-puliscifiltri-catalogo-lista]").addClass("link-primary");
                $("[data-sav-puliscifiltri-catalogo-lista]").removeClass("link-secondary");
                filtriAttivati = false;
            }
        }

        interface BaseFiltriOptions {
            divTabella: string;
            bodyTabella: string;
            baseUrlFiltro: string;
            rigaTabella: string;
            loadStatusClass: string;
        }
        interface RequestCatalogoDto extends Controlli.UtilityTabella.BaseFiltriListaDto {
            connectionId: string;
            categoriaId?: number;
            sottoCategoriaId?: number;
            marcheSelezionate?: number[];
            elencoTagSelezionati?: number[];
            isNovita: boolean;
            evidenzaArticoli?: TabsFiltriCatalogo;
            CatalogoSelezionatoId?: number;
        }
        enum TabsFiltriCatalogo {
            ND = 0,
            PIU_CONSULTATI = 1,
            NOVITA = 2,
            IN_EVIDENZA = 5,
            PIU_VENDUTI = 11,
            IN_SCADENZA = 20,
            IN_PROMO = 6,
            PROMO_R = 7,
            PROMO_C = 8,
            PIU_VOTATI = 15,
            GIA_ACQUISTATI = 16,
            RACCOMANDATI = 30,
            SUGGERITI = 31,
            INEVASI = 32
        }
    }
}